<template>
  <div class="home" :class="isKf ? '' : 'homeH5'">
    <div class="wrap">
      <div class="titleBox">
        <div class="left" v-if="isKf">
          <img :src="imgUrl + userInfo.avatar" alt="" class="head_portrait" />
          <!-- 解码userInfo.nickname  -->
          <span style="color: #fff">{{ decodeURIComponent(userInfo.nickname || userInfo.username) }}</span>
        </div>
        <div v-if="!isKf">
          <span style="color: #fff">客服聊天</span>
        </div>
        <div class="goOut" @click="gooutBtn" v-if="isKf">退出登录</div>
      </div>
      <!-- 内容 -->
      <div class="infoBox" :class="isKf ? '' : 'infoBoxH5'">
        <!-- 左边用户列表 -->
        <div class="userList" v-show="isKf">
          <div class="searchBox">
            <el-input placeholder="请输入内容" v-model="search" class="input-with-select" @input="inquire">
              <el-button slot="prepend" icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <div class="userListBox">
            <div v-for="(item, index) in userListData" :key="index" @click="getAct(item, index)">
              <div v-if="userInfo.id == item.to_uid" :class="item.chat_sign == act ? 'userFlexAct' : 'userFlex'">
                <div class="header">
                  <img :src="imgUrl + item.from_user_avatar" alt="" class="head_portrait2" />
                  <div class="status" v-if="item.unread_num > 0">{{ item.unread_num }}</div>
                </div>
                <div class="userRight">
                  <div class="userInfoBox">
                    <div class="nameBox">
                      <div style="color: #565656" class="userName">
                        {{ item.from_user_nickname }}
                      </div>
                    </div>
                    <div class="timer">{{ $method.formatDate2(parseInt(item.last_content_time)) }}</div>
                  </div>
                  <div class="userInfo" v-if="item.last_content_type == 'text'">{{ item.last_content }}</div>
                </div>
              </div>
              <div v-if="userInfo.id == item.from_uid" :class="item.chat_sign == act ? 'userFlexAct' : 'userFlex'">
                <div class="header">
                  <img :src="imgUrl + item.to_user_avatar" alt="" class="head_portrait2" />
                  <div class="status" v-if="item.unread_num > 0">{{ item.unread_num }}</div>
                </div>
                <div class="userRight">
                  <div class="userInfoBox">
                    <div class="nameBox">
                      <div style="color: #565656" class="userName">
                        {{ item.to_user_nickname }}
                      </div>
                    </div>
                    <div class="timer">{{ $method.formatDate2(parseInt(item.last_content_time)) }}</div>
                  </div>

                  <div class="userInfo" v-if="item.last_content_type == 'text'">{{ item.last_content }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右边输入框和信息展示 -->
        <div class="infoList" :class="isKf ? '' : 'infoListH5'">
          <!-- 信息 -->
          <div class="infoTop" ref="scrollBox" id="box" :class="isKf ? '' : 'infoTopH5'">
            <div class="loading" v-if="load">
              <el-button type="primary" :loading="true">加载中</el-button>
            </div>
            <div v-for="(item, index) in userInfoList" :key="index">
              <p class="time" v-if="index == 0">{{ $method.displayMessage(null, item.create_time) }}</p>
              <p class="time" v-else>{{ $method.displayMessage(userInfoList[index - 1].create_time, item.create_time) }}
              </p>
              <!-- <div :class="item.to_uid == userInfo.id ? 'chatInfoLeft' : 'chatInfoRight'">
                <img :src="item.from_avatar" alt="" class="head_portrait2" />
                <div :class="item.to_uid == userInfo.id ? 'chatLeft' : 'chatRight'">
                  <div class="texts">{{ item.content }}</div>
                </div>
              </div> -->
              <div v-if="item.to_uid == userInfo.id" class="chatInfoLeft">
                <img :src="imgUrl + item.from_avatar" alt="" class="head_portrait2" />
                <div class="chatLeft">
                  <div class="texts" v-if="item.type == 'text'"
                    :class="emojiMaplist.includes(item.content) ? 'emoji' : ''">{{ item.content }}</div>
                  <img class="img" :src="imgUrl + item.content" alt="" v-if="item.type == 'image'">
                </div>
              </div>
              <div v-else class="chatInfoRight">
                <img :src="imgUrl + (item.from_avatar || userInfo.avatar)" alt="" class="head_portrait2" />
                <div class="chatRight">
                  <div class="texts" v-if="item.type == 'text'"
                    :class="emojiMaplist.includes(item.content) ? 'emoji' : ''">{{ item.content }}</div>
                  <img class="img" :src="imgUrl + item.content" alt="" v-if="item.type == 'image'">

                </div>
              </div>
            </div>
          </div>
          <!-- 输入框 -->
          <div class="infoBottom" :class="isKf ? '' : 'infoBottomH5'">


            <!-- <div class="btns"></div> -->
            <div class=" " @click="setUp1" v-show="isshow == 1 ? true : false">
              <img src="../assets/biaoqing.png" style="width: 32px;">
            </div>
            <textarea type="textarea" class="infoInput" :class="isKf ? '' : 'infoInputH5'" v-model="textarea"
              @keydown.enter.exact="handlePushKeyword($event)" @keyup.ctrl.enter="lineFeed"
              :disabled='isshow == 1 ? false : true'></textarea>
            <div class=" " @click="setUp2" v-show="isshow == 1 ? true : false">
              <img src="../assets//tupian.png" style="width: 32px;">
            </div>
            <input type="file" ref="fileInput" accept="image/*" @change="handleFileChange"
              style="opacity: 0;position: fixed;left: -98999px;">
            <div class="fasong" @click="setUp('text')" v-show="isshow == 1 ? true : false">发送</div>

            <div v-if="showEmoji" class="emojiBox">
              <div v-for="(item, index) in emojiMaplist" :key="index" class="emojiItem"
                @click="showEmoji = 0; setUp('text', item)">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <!-- 当前聊天的用户信息资料 -->
        <div class="userinfoBox" v-show="isKf">
          <div class="userBox" v-if="userInfo.id == nowMess.to_uid">
            <div class="pic">
              <img :src="imgUrl + nowMess.from_user_avatar" alt="" />
            </div>
            <div>
              <p class="name">{{ nowMess.from_user_nickname }}</p>
              <div class="idBox">
                <p class="id">ID:{{ nowMess.from_uid }}</p>
                <div class="icon" @click="copyText(nowMess.from_uid)">
                  <img src="../assets/fuzhi.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="userBox" v-if="userInfo.id == nowMess.from_uid">
            <div class="pic">
              <img :src="imgUrl + nowMess.to_user_avatar" alt="" />
            </div>
            <div>
              <p class="name">{{ nowMess.to_user_nickname }}</p>
              <div class="idBox">
                <!-- <p class="id">ID:{{ nowMess.to_uid }}</p> -->
                <!-- {{ nowMess }} -->
                <p class="id">手机号:{{ nowMess.to_user_mobile }}</p>
                <!-- to_uid -->
                <div class="icon" @click="copyText(nowMess.to_user_mobile)">
                  <img src="../assets/fuzhi.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="infoListbox" v-if="userOpen && 0">
            <div class="info">
              <p class="title">助教ID</p>
              <div class="conBox">
                <p class="content">{{ nowMessuser.link_uid }}</p>
                <div class="icon" @click="copyText(nowMessuser.link_uid)">
                  <img src="../assets/fuzhi.png" alt="">
                </div>
              </div>
            </div>
            <div class="info">
              <p class="title">助教头像</p>
              <div class="conBox">
                <img class="head" :src="imgUrl + nowMessuser.link_avatar" alt="" />
              </div>
            </div>
            <div class="info">
              <p class="title">助教名称</p>
              <div class="conBox">
                <p class="content">{{ nowMessuser.link_nickname }}</p>
                <div class="icon" @click="copyText(nowMessuser.link_nickname)">
                  <img src="../assets/fuzhi.png" alt="">
                </div>
              </div>
            </div>
            <div class="info">
              <p class="title">球房ID</p>
              <div class="conBox">
                <p class="content">{{ nowMessuser.link_ball_id }}</p>
                <div class="icon" @click="copyText(nowMessuser.link_ball_id)">
                  <img src="../assets/fuzhi.png" alt="">
                </div>
              </div>
            </div>
            <div class="info">
              <p class="title">球房名称</p>
              <div class="conBox">
                <p class="content">{{ nowMessuser.link_ball_name }}</p>
                <div class="icon" @click="copyText(nowMessuser.link_ball_name)">
                  <img src="../assets/fuzhi.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bus } from '../main'
import { Message } from 'element-ui';
export default {
  data() {
    return {
      isKf: 0,
      imgUrl: 'https://www.migezhihui.com',
      load: false,
      userInfo: {},
      // 在线状态
      state: 1,
      //搜索用户
      search: "",
      //用户列表渲染数据
      userListData: [
        {
          chat_sign: 1,
        }
      ],
      userInfoList: [],
      userListDatas: [],
      //用户点击选中变色
      act: '',
      //历史信息
      //输入框
      textarea: "",
      //滚动条距离顶部距离
      scrollTop: 0,
      //发送和输入显隐
      isshow: 0,
      // 当前聊天的人
      nowMess: {},
      page: 1,
      more: true,
      nowMessuser: {}, //当前聊天用户信息
      userOpen: false,
      nowIndex: null,
      nowId: null,
      showEmoji: false, previewUrl: '',       // 图片预览地址
      uploadProgress: 0,    // 上传进度
      uploadStatus: ''      // 上传状态：success/error
    };
  },
  activated() {
    this.page = 1;
    this.getuserList();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  beforeMount() {
    function getUrlParam(paraName) {
      var url = document.location.toString();
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      }
      else {
        return "";
      }
    }

    let token = getUrlParam("token");
    let userInfo = {
      nickname: getUrlParam("nickname"),
      avatar: getUrlParam("avatar"),
      id: getUrlParam("id"),
      to_uid: getUrlParam("to_uid"),
      token: token
    }
    if (token) {
      window.localStorage.setItem("isKf", 0);
      window.localStorage.setItem("token", token);
      window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
      console.log('WebSocket init 1111')
      this.websocket.Init();

    }
    this.isKf = window.localStorage.getItem('isKf') - 0

  },
  mounted() {
    // 接收消息 并进行分发
    Bus.$on('appendMessage', (res) => {
      console.log(res, 'appendMessage');
      if (res) {
        let that = this;
        let data = res.data;
        if (data.chat_sign == that.nowMess.chat_sign) {
          // 当前聊天和接受的消息为同一个人时  拼接数组
          console.log(123)
          let str = {
            from_uid: data.from_uid,
            to_uid: data.to_uid,
            content: data.content,
            type: data.type,
            from_avatar: data.from_user_avatar,
            create_time: that.$method.formatDate((res.time) * 1000)
          }
          that.userInfoList.push(str);
          let index = that.userListData.findIndex(item => item.chat_sign === data.chat_sign);
          // 如果找到了该项
          if (index !== -1) {
            that.userListData[index].last_content = data.content;
            that.userListData[index].last_content_time = (res.time) * 1000;
            let arr = that.userListData.splice(index, 1)[0];
            that.userListData.unshift(arr);
            that.userListDatas = JSON.parse(JSON.stringify(that.userListData));
          }
          that.$nextTick(() => {
            // 一定要用nextTick
            that.setPageScrollTo();
            //页面滚动条距离顶部高度等于这个盒子的高度
            that.$refs.scrollBox.scrollTop = that.$refs.scrollBox.scrollHeight;
          })
        } else {
          // 不为同一人时 消息数添加  并且 上移
          console.log(111)
          let index = that.userListData.findIndex(item => item.chat_sign === data.chat_sign);
          if (!this.isKf) index = 0
          if (index !== -1) {
            that.userListData[index].unread_num += 1;
            that.userListData[index].last_content = data.content;
            that.userListData[index].last_content_time = (res.time) * 1000;
            let arr = that.userListData.splice(index, 1)[0];
            that.userListData.unshift(arr);
            that.userListDatas = JSON.parse(JSON.stringify(that.userListData));
          } else {
            that.getuserList();
          }
        }
      }
    })
  },
  methods: {
    // 获取用户列表
    getuserList() {
      this.$postRequest("kefu/chat/getContactsList").then((res) => {
        if (res.code == 200) {
          this.userListData = res.data;
          this.userListDatas = JSON.parse(JSON.stringify(this.userListData));
          if (!this.isKf && res.data.length == 0) {
            this.userListData = [
              { chat_sign: `${this.userInfo.id}-${this.userInfo.to_uid}` }
            ]
          }
          if (!this.isKf) {
            this.getAct(this.userListData[0], 0)

          }
        }
      });
    },
    // 获取用户信息
    getAssistantInfo(id) {
      this.$postRequest("kefu/chat/getAssistantInfo", {
        chat_sign: id
      }).then((res) => {
        if (res.code == 200) {
          this.userOpen = true;
          this.nowMessuser = res.data;
        }
      });
    },
    // 获取聊天记录
    getChatRecordList(id) {
      this.$postRequest("kefu/chat/getChatRecordList", {
        chat_sign: id,
        page: this.page
      }).then((res) => {
        if (res.code == 200) {
          this.load = false;
          let data = res.data.data;
          if (this.page == 1) {
            this.userInfoList = data.reverse();
          } else {
            this.userInfoList = [...data.reverse(), ...this.userInfoList];
          }
          if (this.page == 1) {
            this.$nextTick(() => {
              this.setPageScrollTo();
              //页面滚动条距离顶部高度等于这个盒子的高度
              this.$refs.scrollBox.scrollTop = this.$refs.scrollBox.scrollHeight;
            })
          } else {
            this.$nextTick(() => {
              //页面滚动条距离顶部高度等于这个盒子的高度
              this.setPageScrollTo();
            })
          }
          if (res.data.last_page > this.page) {
            this.load = true;
            this.more = true;
            this.page++;
          } else {
            this.more = false;
          }
        }
      });
    },
    //点击用户
    getAct(val, index) {
      if (val.chat_sign == this.nowId) {
        return
      }
      this.nowId = val.chat_sign;
      this.page = 1;
      this.isshow = 1
      this.$refs.scrollBox.removeEventListener("scroll", this.srTop);
      this.act = val.chat_sign;
      this.nowMess = val;
      this.userListData[index].unread_num = 0;
      this.userListDatas = JSON.parse(JSON.stringify(this.userListData));
      this.userInfoList = [];
      this.getAssistantInfo(val.chat_sign);
      this.getChatRecordList(val.chat_sign);
    },
    // 模糊搜索用户
    inquire() {
      let fuzzy = this.search;
      if (fuzzy) {
        this.userListData = this.userListDatas.filter((item) => {
          return item.to_user_nickname.includes(fuzzy);
        });
      } else {
        this.userListData = this.userListDatas;
      }
    },
    // 处理选择的文件
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (!this.validateFile(file)) return;      // 验证文件类型和大小
      // this.createPreview(file); // 生成预览图   
      this.uploadFile(file);   // 上传文件     
      e.target.value = ''; // 重置文件输入，允许重复选择同一文件
    },

    // 验证文件
    validateFile(file) {      // 验证文件类型
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        alert('请选择图片文件！');
        return false;
      }
      // 验证文件大小（这里限制5MB）
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        alert('图片大小不能超过5MB！');
        return false;
      }
      return true;
    },
    // 创建预览图
    createPreview(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadFile(file) {
      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', file);
      this.$postRequest("kefu/file/upload", formData).then((res) => {
        if (res.code == 200) {
          console.log(123, res)
          this.setUp('image', res.data.src);
        }
      });
    },

    setUp1() {//发送表情
      this.showEmoji = !this.showEmoji;
    },
    setUp2() {//发送图片
      this.$refs.fileInput.click();
    },
    //发送
    setUp(type, content) {
      if (type == 'text' && !content && !this.textarea) {
        Message({
          message: "请输入内容",
          type: "warning",
        });
        return
      }
      let chat_sign = this.nowMess.chat_sign.split('-');
      let to_uid = this.isKf ?
        chat_sign[0] == this.userInfo.id ? chat_sign[1] : chat_sign[0] :
        0;
      this.$postRequest("kefu/chat/sendMessage", {
        // chat_sign: this.nowMess.chat_sign,
        content: content || this.textarea,
        type,
        to_uid,//客服要穿
      }).then((res) => {
        if (res.code == 200) {
          // 发送
          let numdata = {
            type,
            chat_sign: this.nowMess.chat_sign,
            content: content || this.textarea
          }
          this.websocket.Send(numdata);
          // 拼接数组
          let str = {
            type,
            content: content || this.textarea,
            create_time: this.$method.getNowTime(1)
          }
          if (this.userInfo.id == this.nowMess.from_uid) {
            str.from_uid = this.nowMess.from_uid;
            str.to_uid = this.nowMess.to_uid;
            str.from_avatar = this.nowMess.from_user_avatar,
              str.link_avatar = this.nowMessuser.link_avatar
          } else {
            str.from_uid = this.nowMess.to_uid;
            str.to_uid = this.nowMess.from_uid;
            str.from_avatar = this.nowMess.to_user_avatar,
              str.link_avatar = this.nowMessuser.link_avatar
          }
          this.userInfoList.push(str);
          console.log(str, this.userInfoList)
          let index = this.userListData.findIndex(item => item.chat_sign === this.nowMess.chat_sign);
          // 如果找到了该项
          if (index !== -1) {
            this.userListData[index].last_content = this.textarea;
            this.userListData[index].last_content_time = this.$method.getNowTime(2);
            let arr = this.userListData.splice(index, 1)[0];
            this.userListData.unshift(arr);
            this.userListDatas = JSON.parse(JSON.stringify(this.userListData));
          }
          this.textarea = "";
          this.$nextTick(() => {
            // 一定要用nextTick
            this.setPageScrollTo();
            //页面滚动条距离顶部高度等于这个盒子的高度
            this.$refs.scrollBox.scrollTop = this.$refs.scrollBox.scrollHeight;
          })
        }
      });
    },
    // 监听键盘回车阻止换行并发送
    handlePushKeyword(event) {
      console.log(event);
      if (event.keyCode === 13) {
        event.preventDefault(); // 阻止浏览器默认换行操作
        this.setUp('text'); //发送文本
        return false;
      }
    },
    // 监听按的是ctrl + 回车，就换行
    lineFeed() {
      console.log("换行");
      this.textarea = this.textarea + "\n";
    },
    //点击icon
    extend(val) {
      alert("你点击了：" + val);
    },
    //滚动条默认滚动到最底部
    setPageScrollTo(s, c) {
      //获取中间内容盒子的可见区域高度
      this.scrollTop = document.querySelector("#box").offsetHeight;
      setTimeout((res) => {
        //加个定时器，防止上面高度没获取到，再获取一遍。
        if (this.scrollTop != this.$refs.scrollBox.offsetHeight) {
          this.scrollTop = document.querySelector("#box").offsetHeight;
          console.log(this.scrollTop, '====')
        }
      }, 100);
      //scrollTop：滚动条距离顶部的距离。
      //把上面获取到的高度座位距离，把滚动条顶到最底部
      this.$refs.scrollBox.scrollTop = this.scrollTop;
      setTimeout(() => {
        this.$refs.scrollBox.scrollTop = this.scrollTop + 99999;
      }, 100);
      //判断是否有滚动条,有滚动条就创建一个监听滚动事件，滚动到顶部触发srTop方法
      if (this.$refs.scrollBox.scrollTop > 0) {
        this.$refs.scrollBox.addEventListener("scroll", this.srTop);
      }
    },
    //滚动条到达顶部
    srTop() {
      //判断：当滚动条距离顶部为0时代表滚动到顶部了
      if (this.$refs.scrollBox.scrollTop == 0) {
        if (this.more) {
          this.getChatRecordList(this.nowMess.chat_sign);
        }
      }
    },
    // 复制
    async copyText(text) {
      try {
        // 使用Clipboard API复制文本
        await navigator.clipboard.writeText(text);
        Message({
          message: "文本已复制到剪贴板",
          type: "success",
        });
      } catch (err) {
        console.error('复制失败', err);
        // 兼容性处理，如果Clipboard API不可用，尝试使用旧的execCommand方法（虽然不推荐）
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          Message({
            message: "文本已复制到剪贴板",
            type: "success",
          });
        } catch (e) {
          console.error('无法使用execCommand方法', e);
        } finally {
          document.body.removeChild(textArea);
        }
      }
    },
    // 退出登录
    gooutBtn() {
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('userInfo');
      Message({
        message: "退出登录",
        type: "warning",
      });
      this.$router.replace('/login');
    }
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
  user-select: none;
  display: block;
  object-fit: cover;
}

.loading {
  display: flex;
  align-items: center;
}

::v-deep.el-button--primary {
  background-color: transparent !important;
  border: none;
  color: #333333;
  margin: 0 auto;
}

.home {
  height: 100vh;
  width: 100vw;
  background-color: #ededed;
  display: flex;
  align-items: center;
  justify-content: center;
}


.wrap {
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.titleBox {
  height: 70px;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  background: linear-gradient(270deg, #1890ff, #3875ea);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #FFFFFF;

  .left {
    display: flex;
    align-items: center;
  }

  .head_portrait {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .goOut {
    padding: 5px 10px;
    border: 1px solid #FFFFFF;
    border-radius: 5px;
    font-size: 15px;
    color: #FFFFFF;
    line-height: 1;
    cursor: pointer;
  }
}

.stateBox {
  margin-left: 20px;
  padding: 1px 8px;
  background-color: #eaffeb;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  color: rgba(0, 0, 0, .65);
}

.stateBox2 {
  margin-left: 20px;
  padding: 1px 8px;
  background-color: #fff;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
}

.stateBox2:hover {
  background-color: #dcdcdc;
}

/* 在线 */
.state1 {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #8ee80e;
}

/* 离线 */
.state2 {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #cacaca;
}

/* 退出登录 */
.state4 {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #7e7e7e;
}

.stateText {
  font-size: 14px;
  margin-left: 5px;
}

.infoBox {
  height: 730px;
  width: 100%;
  display: flex;
}


.userList {
  height: 100%;
  width: 320px;
  border-right: 1px solid #ccc;
  display: flex;
  flex-direction: column;

  .searchBox {
    padding: 4px 10px;

    .input-with-select {
      width: 100%;
    }

    .searchIcon {
      height: 100%;
      width: 50px;
      background: #f8f8f9;
    }
  }
}

/* 用户列表 */
.userListBox {
  flex: 1;
  width: 100%;
  overflow: auto;

  .userFlexAct {
    width: 100%;
    height: 70px;
    padding: 12px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: start;
    background: #eff0f1;
    cursor: pointer;
    border-left: 3px solid #1890ff;
  }

  .userFlex {
    width: 100%;
    height: 70px;
    padding: 12px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: start;
    background: #FFFFFF;
    cursor: pointer;
    border-left: 3px solid transparent;
  }

  .header {
    position: relative;
    flex-shrink: 0;

    .head_portrait2 {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    .status {
      min-width: 15px;
      padding: 0 3px;
      height: 15px;
      box-sizing: border-box;
      background: #FF0000;
      position: absolute;
      right: -2px;
      top: -2px;
      border-radius: 15px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      line-height: 1;
    }
  }

  .userRight {
    margin-left: 12px;
    flex: 1;

    .userInfoBox {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .nameBox {
        display: flex;
        align-items: center;
      }
    }

    .userName {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.65);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }

    .phone {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      flex-shrink: 0;
    }

    .userInfo {
      font-size: 12px;
      color: #8E959E;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      margin-top: 3px;
    }
  }

  .timer {
    font-size: 14px;
    color: #8E959E;
    flex-shrink: 0;
    margin-left: 10px;
    margin-top: 2px;
  }
}

/* 信息外层盒子 */
.infoList {
  height: 100%;
  width: 600px;
}


/* 信息列表 */
.infoTop {
  height: calc(100% - 50px);
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;

  .time {
    text-align: center;
    color: #8E959E;
    font-size: 12px;
    margin-top: 10px;
  }

  .head_portrait2 {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .img {
    width: 200px;
  }

  /* 对方发的信息样式 */
  .chatInfoLeft {
    min-height: 70px;
    margin-left: 10px;
    margin-top: 10px;
    display: flex;

    .chatLeft {
      margin-left: 15px;
      flex: 1;

      .texts {
        max-width: 320px;
        background: #f5f5f5;
        border-radius: 10px;
        color: #000000;
        font-size: 14px;
        padding: 9px;
        overflow: hidden;
        display: inline-block;
        white-space: normal;
        word-break: break-all;
        white-space: pre-wrap;
      }
    }
  }

  /* 自己发的信息样式 */
  .chatInfoRight {
    min-height: 70px;
    margin-left: 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: row-reverse;

    .chatRight {
      margin-right: 15px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .texts {
        max-width: 320px;
        background: #95ec69;
        border-radius: 10px;
        color: #000000;
        font-size: 14px;
        padding: 9px;
        overflow: hidden;
        display: inline-block;
        white-space: normal;
        word-break: break-all;
        white-space: pre-wrap;
      }
    }
  }
}



.infoBottom {
  height: 50px;
  display: flex;
  align-items: center;
  background: #F7F7F7;
  padding: 8px;
  box-sizing: border-box;

  /* 输入框 */
  .infoInput {
    height: 100%;
    flex: 1;
    margin: 0 8px;
    border: none;
    resize: none;
    padding: 8px;
    box-sizing: border-box;
    outline: none;
    font-size: 14px;
    color: #515a6e;
    background-color: #fff;
  }


  .btns {
    display: flex;
  }

  .fasong {
    width: 48px;
    height: 32px;
    background: #FFA100;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    margin-left: 8px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}



.fasong1 {
  right: 206px !important;

}

.fasong2 {
  right: 110px !important;

}

.userinfoBox {
  width: 300px;
  padding: 10px;
  border-left: 1px solid #ccc;

  .userBox {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #EAEAEA;

    .pic {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      flex-shrink: 0;

      image {
        width: 50px;
        height: 50px;
      }
    }

    .name {
      color: #333333;
      font-size: 15px;
    }

    .idBox {
      display: flex;
      align-items: center;
      margin-top: 5px;
    }

    .id {
      color: #333333;
      font-size: 13px;
    }

    .icon {
      width: 15px;
      height: 15px;
      margin-left: 5px;
      cursor: pointer;
      flex-shrink: 0;

      image {
        width: 15px;
        height: 15px;
      }
    }
  }

  .infoListbox {
    padding: 10px 0;
    border-bottom: 1px solid #EAEAEA;

    .info {
      padding: 5px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        color: #666666;
        flex-shrink: 0;
      }

      .head {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
      }

      .conBox {
        display: flex;
        align-items: center;
        margin-left: 10px;

        .content {
          color: #666666;
        }

        .icon {
          width: 15px;
          height: 15px;
          margin-left: 5px;
          cursor: pointer;
          flex-shrink: 0;

          image {
            width: 15px;
            height: 15px;
          }
        }
      }
    }
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 7px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #dbd9d9;
  border-radius: 3px;
}

.emojiBox {
  position: absolute;
  bottom: 50px;
  right: 15px;
  width: 95%;
  height: 200px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;

  .emojiItem {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    cursor: pointer;
    font-size: 28px;
    margin: 3px;
  }
}

.emoji {
  font-size: 30px !important;
}



.homeH5 {
  align-items: flex-start;

  .infoBoxH5 {
    height: calc(100vh - 70px);
    width: 100vw;
    overflow: hidden;

    .infoListH5 {
      width: 100%;
      height: 100%;

      // .infoTopH5 {
      //   height: calc(100% - 50px);
      //   box-sizing: border-box;
      // }

      // .infoBottomH5 {
      //   height: 100px;

      //   .infoInputH5 {
      //     height: 70px;
      //   }
      // }
    }
  }
}
</style>
